// Module
var code = "<template> <div ref=\"bgElement\"> <div class=\"container\"> <div dt-grid-row ref=\"rowElement\" class=\"r-container-row dt-grid-row--single-col\"> <div dt-grid-col=\"s:12; l-offset.bind: lOffset; l.bind: l\" ref=\"colElement\"> <div ref=\"fgElement\"> <slot></slot> </div> </div> </div> </div> </div> </template>";
// Exports
export default code;